import { useEffect, useState } from "react";
import DonutChartProfile from "../Layouts/Graphs/DonutChartProfile";
import ProgressBar from "react-bootstrap/ProgressBar";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import {
  getProfileCompletionReport,
  getProfileCompletionReportClear,
} from "../../redux/reports/actions";
import { SessionKeys } from "../../utils/AppUtils";
import ContentDetailComponent from "./ContentDetailComponent";
import Loader from "../Loader/Loader";
import { is } from "immutable";

const ProfileDetailComponent = ({ isVideos, isOther, userId, asset_id }) => {
  let dispatch = useDispatch();
  const [profileReports, setProfileReports] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [profileFilterReports, setProfileFilterReports] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedBox, setSelectedBox] = useState("");

  const profileReportRes = useSelector((state) => state.report.profileReport);
  const [stats, setStats] = useState({
    completed: 0,
    inprogress: 0,
    overdue: 0,
    notStarted: 0,
  });

  // const [series, setSeries] = useState([]);
  // const [labels, setLabels] = useState([
  //   "Completed",
  //   "In Progress",
  //   "Yet to Start",
  //   "Overdue",
  // ]);

  // const [colors, setColors] = useState([
  //   "#A9DBB8",
  //   "#f0a446",
  //   "#59564d",
  //   "#ff4560",
  // ]);

  const [sections, setSections] = useState([]);
  useEffect(() => {
    if (!_.isEmpty(profileReportRes)) {
      if (profileReportRes?.status === "success") {
        const reportData = profileReportRes?.payload?.payload?.user_data;
        let series = [];
        let sections_data = [];
        console.log("crs-report--", reportData);

        stats.completed = reportData?.filter(
          (data) => _.toLower(data.profile_status) === "completed"
        ).length;

        stats.notStarted = reportData?.filter(
          (data) =>
            _.toLower(data.profile_status) === "not-started" ||
            _.toLower(data.profile_status) === "yet to start"
        ).length;
        stats.inprogress = reportData?.filter(
          (data) =>
            _.toLower(data.profile_status) === "in-progress" ||
            _.toLower(data.profile_status) === "inprogress"
        ).length;
        if (!isVideos) {
          stats.inprogress = reportData?.filter(
            (data) =>
              _.toLower(data.profile_status) === "in-progress" ||
              _.toLower(data.profile_status) === "inprogress"
          ).length;

          stats.overdue = reportData?.filter(
            (data) =>
              _.toLower(data.profile_status) === "overdue" ||
              data.profile_status === "over-due"
          ).length;
        }

        let total = isVideos
          ? stats.completed + stats.notStarted
          : stats.completed +
            stats.inprogress +
            stats.notStarted +
            stats.overdue;

        if (stats.completed > 0) {
          let per = (stats.completed / total) * 100;
          sections_data.push({
            value: per,
            color: "rgba(71, 196, 120, 1)",
            label: "Completed",
          });
        }

        if (stats.notStarted > 0) {
          let per = (stats.notStarted / total) * 100;
          sections_data.push({
            value: per,
            color: "rgba(144, 152, 154, 1)",
            label: "Yet to start",
          });
        }
        if (stats.inprogress > 0) {
          let per = (stats.inprogress / total) * 100;
          sections_data.push({
            value: per,
            color: "rgba(240, 164, 70, 1)",
            label: "In Progress",
          });
        }
        if (!isVideos) {
          if (stats.inprogress > 0) {
            let per = (stats.inprogress / total) * 100;
            sections_data.push({
              value: per,
              color: "rgba(240, 164, 70, 1)",
              label: "In Progress",
            });
          }

          if (stats.overdue > 0) {
            let per = (stats.overdue / total) * 100;
            sections_data.push({
              value: per,
              color: "rgba(239, 103, 121, 1)",
              label: "Overdue",
            });
          }
        }
        setSections(sections_data);
        const sortedData = _.sortBy(reportData, [
          (report) => report?.course_name?.toLowerCase(),
        ]);
        console.log("course data", sortedData);
        const transformedArray = sortedData.map((item, index) => ({
          sl_no: index + 1,
          name: item.course_name,
          status: item.profile_status,
          progress: item.profile_progress,
          id: item?.e_id,
          code: item?.e_code,
          source: item?.e_source,
          course_status: item?.course_status,
          is_disabled: item?.is_disabled,
        }));

        console.log("transformed Array", transformedArray);
        setProfileReports(transformedArray);
        setProfileFilterReports(transformedArray);
      } else {
        setProfileReports([]);
      }
      setIsLoading(false);
      dispatch(getProfileCompletionReportClear());
    }
  }, [profileReportRes]);

  const courseDataReport = (reaId) => {
    dispatch(
      getProfileCompletionReport({
        module: "getCourseProgressReport",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          limit: 1,
          rea_ids: reaId,
          entity_id: [],
          office_ids: [],
          provider_ids: [],
          compliance: 0,
          manager_ids: [],
          date_range: {
            start: "",
            end: "",
          },
          status: ["completed", "in-progress", "overdue", "not-started"],
          role: ["participant", "reporting_manager", "program_manager", "all"],
          // is_videos: isVideos,
          asset_id: asset_id || [],
        },
      })
    );
  };

  useEffect(() => {
    setSelectedBox("");
    let reaId = [];
    reaId.push(userId);
    setIsLoading(true);
    setIsNameAsc(true);
    setIsStatusAsc("");
    setIsProgressAsc("");
    setSearchText("");
    setSections([]);
    setStats({
      completed: 0,
      inprogress: 0,
      overdue: 0,
      notStarted: 0,
    });
    courseDataReport(reaId);
    return () => {
      dispatch(getProfileCompletionReportClear());
    };
  }, [isVideos]);

  const onSearchClicked = () => {
    setIsLoading(true);
    if (
      searchText === "" ||
      searchText === "undefined" ||
      searchText === null
    ) {
      setSelectedBox("");
      statsCal(profileFilterReports);
      setProfileReports(profileFilterReports);
    } else {
      let searchedData = [];
      let data = selectedBox === "" ? profileFilterReports : profileReports;
      for (let item of data) {
        if (_.toLower(item?.name)?.includes(_.toLower(searchText))) {
          searchedData.push(item);
        }
      }
      statsCal(searchedData);
      setProfileReports(searchedData);
    }
    setIsLoading(false);
  };

  const statsCal = (searchedData) => {
    let sections_data = [];
    stats.completed = searchedData?.filter(
      (data) => _.toLower(data.status) === "completed"
    ).length;

    stats.notStarted = searchedData?.filter(
      (data) =>
        _.toLower(data.status) === "not-started" ||
        _.toLower(data.status) === "yet to start"
    ).length;
    stats.inprogress = searchedData?.filter(
      (data) =>
        _.toLower(data.status) === "in-progress" ||
        _.toLower(data.status) === "inprogress"
    ).length;
    if (!isVideos) {
      stats.inprogress = searchedData?.filter(
        (data) =>
          _.toLower(data.status) === "in-progress" ||
          _.toLower(data.status) === "inprogress"
      ).length;

      stats.overdue = searchedData?.filter(
        (data) =>
          _.toLower(data.status) === "overdue" || data.status === "over-due"
      ).length;
    }

    let total = isVideos
      ? stats.completed + stats.notStarted
      : stats.completed + stats.inprogress + stats.notStarted + stats.overdue;

    if (stats.completed > 0) {
      let per = (stats.completed / total) * 100;
      sections_data.push({
        value: per,
        color: "rgba(71, 196, 120, 1)",
        label: "Completed",
      });
    }
    if (stats.notStarted > 0) {
      let per = (stats.notStarted / total) * 100;
      sections_data.push({
        value: per,
        color: "rgba(144, 152, 154, 1)",
        label: "Yet to start",
      });
    }
    if (stats.inprogress > 0) {
      let per = (stats.inprogress / total) * 100;
      sections_data.push({
        value: per,
        color: "rgba(240, 164, 70, 1)",
        label: "In Progress",
      });
    }
    if (!isVideos) {
      if (stats.inprogress > 0) {
        let per = (stats.inprogress / total) * 100;
        sections_data.push({
          value: per,
          color: "rgba(240, 164, 70, 1)",
          label: "In Progress",
        });
      }

      if (stats.overdue > 0) {
        let per = (stats.overdue / total) * 100;
        sections_data.push({
          value: per,
          color: "rgba(239, 103, 121, 1)",
          label: "Overdue",
        });
      }
    }
    setSections(sections_data);
  };

  const [isNameAsc, setIsNameAsc] = useState(true);
  const [isProgressAsc, setIsProgressAsc] = useState("");
  const [isStatusAsc, setIsStatusAsc] = useState("");

  const setNameOrder = () => {
    setIsNameAsc(!isNameAsc);
  };

  useEffect(() => {
    console.log("course data isCourseAsc", isNameAsc);
    if (isNameAsc) {
      const sortedData = _.orderBy(
        profileReports,
        [(report) => report?.name?.toLowerCase()],
        "asc"
      );
      console.log("course data asc", sortedData);
      const transformedArray = sortedData.map((item, index) => ({
        sl_no: index + 1,
        name: item.name,
        status: item.status,
        progress: item.progress,
        id: item?.e_id,
        code: item?.e_code,
        source: item?.source,
        course_status: item?.course_status,
        is_disabled: item?.is_disabled,
      }));
      setProfileReports(transformedArray);
    } else {
      const sortedData = _.orderBy(
        profileReports,
        [(report) => report?.name?.toLowerCase()],
        "desc"
      );
      console.log("course data desc", sortedData);
      const transformedArray = sortedData.map((item, index) => ({
        sl_no: index + 1,
        name: item.name,
        status: item.status,
        progress: item.progress,
        id: item?.e_id,
        code: item?.e_code,
        source: item?.source,
        course_status: item?.course_status,
        is_disabled: item?.is_disabled,
      }));
      setProfileReports(transformedArray);
    }
  }, [isNameAsc]);

  const setProgressOrder = () => {
    if (isProgressAsc === "") {
      setIsProgressAsc(true);
    } else {
      setIsProgressAsc(!isProgressAsc);
    }
  };

  useEffect(() => {
    for (const item of profileReports) {
      item.progress = Number(item.progress);
    }
    console.log("progress data ", profileReports);
    if (isProgressAsc) {
      const sortedData = _.orderBy(profileReports, "progress", "asc");
      console.log("progress data asc", sortedData);
      const transformedArray = sortedData.map((item, index) => ({
        sl_no: index + 1,
        name: item.name,
        status: item.status,
        progress: item.progress,
        id: item?.e_id,
        code: item?.e_code,
        source: item?.source,
        course_status: item?.course_status,
        is_disabled: item?.is_disabled,
      }));
      setProfileReports(transformedArray);
    } else {
      const sortedData = _.orderBy(profileReports, "progress", "desc");
      console.log("progress data desc", sortedData);
      const transformedArray = sortedData.map((item, index) => ({
        sl_no: index + 1,
        name: item.name,
        status: item.status,
        progress: item.progress,
        id: item?.e_id,
        code: item?.e_code,
        source: item?.source,
        course_status: item?.course_status,
        is_disabled: item?.is_disabled,
      }));
      setProfileReports(transformedArray);
    }
  }, [isProgressAsc]);

  const setStatusOrder = () => {
    if (isStatusAsc === "") {
      setIsStatusAsc(true);
    } else {
      setIsStatusAsc(!isStatusAsc);
    }
  };

  useEffect(() => {
    console.log("status data ", isStatusAsc);
    if (isStatusAsc) {
      const sortedData = _.orderBy(
        profileReports,
        [(report) => report?.status?.toLowerCase()],
        "asc"
      );
      console.log("progress data asc", sortedData);
      const transformedArray = sortedData.map((item, index) => ({
        sl_no: index + 1,
        name: item.name,
        status: item.status,
        progress: item.progress,
        id: item?.e_id,
        code: item?.e_code,
        source: item?.source,
        course_status: item?.course_status,
        is_disabled: item?.is_disabled,
      }));
      setProfileReports(transformedArray);
    } else {
      const sortedData = _.orderBy(
        profileReports,
        [(report) => report?.status?.toLowerCase()],
        "desc"
      );
      console.log("progress data desc", sortedData);
      const transformedArray = sortedData.map((item, index) => ({
        sl_no: index + 1,
        name: item.name,
        status: item.status,
        progress: item.progress,
        id: item?.e_id,
        code: item?.e_code,
        source: item?.source,
        course_status: item?.course_status,
        is_disabled: item?.is_disabled,
      }));
      setProfileReports(transformedArray);
    }
  }, [isStatusAsc]);

  useEffect(() => {
    if (!_.isEmpty(selectedBox)) {
      setProfileReports([]);
      setIsLoading(true);
      console.log("selected box---", selectedBox);
      let searchedData = [];
      if (selectedBox === "all") {
        setProfileReports(profileFilterReports);
      } else {
        if (selectedBox === "completed") {
          searchedData.push(
            profileFilterReports?.filter(
              (data) => _.toLower(data.status) === "completed"
            )
          );
          console.log("selected box---searched data---", searchedData);
        }

        if (selectedBox === "yt-start") {
          searchedData.push(
            profileFilterReports?.filter(
              (data) =>
                _.toLower(data.status) === "not-started" ||
                _.toLower(data.status) === "yet to start"
            )
          );
        }
        if (selectedBox === "inprogress") {
          searchedData.push(
            profileFilterReports?.filter(
              (data) =>
                _.toLower(data.status) === "in-progress" ||
                _.toLower(data.status) === "inprogress"
            )
          );
        }
        if (!isVideos) {
          if (selectedBox === "overdue") {
            searchedData.push(
              profileFilterReports?.filter(
                (data) =>
                  _.toLower(data.status) === "overdue" ||
                  data.status === "over-due"
              )
            );
          }
        }
        setProfileReports(searchedData[0]);
      }
      // statsCal(searchedData[0]);

      setIsLoading(false);
    }
  }, [selectedBox]);

  return (
    <>
      <ContentDetailComponent
        isLoading={isLoading}
        stats={stats}
        profileReports={profileReports}
        heading={isVideos ? "Videos" : "Courses"}
        onSearchClicked={onSearchClicked}
        searchText={searchText}
        setSearchText={setSearchText}
        sections={sections}
        isNameAsc={isNameAsc}
        setNameOrder={setNameOrder}
        isProgressAsc={isProgressAsc}
        setProgressOrder={setProgressOrder}
        isStatusAsc={isStatusAsc}
        setStatusOrder={setStatusOrder}
        selectedBox={selectedBox}
        setSelectedBox={setSelectedBox}
        isOther={isOther}
      />
      {/* <div className="profile-info-wrapper">
        <div className="profile-info-title d-flex justify-content-between gap-3 align-items-center flex-wrap">
          <div className="title-box">Courses</div>
          <div className="search-info">
            <div className="input-text position-relative d-flex">
              <label htmlFor="search" className="input__label">
                Search
              </label>
              <input
                type="search"
                id="search"
                name="search"
                className="input_field mr-2"
                placeholder=" "
                value=""
              />
            </div>
          </div>
        </div>
        <div className="graph-prolie-info">
          <div className="graph-shpw">
            <DonutChartProfile />
          </div>
          <div className="graph-info-boxes">
            <div className="graph-info-wrap completed">
              <div class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={32}
                  height={32}
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11.0026 16L6.75999 11.7574L8.17421 10.3431L11.0026 13.1716L16.6595 7.51472L18.0737 8.92893L11.0026 16Z"></path>
                </svg>
              </div>{" "}
              {stats?.completed} Completed
            </div>
            <div className="graph-info-wrap inprogress">
              <div class="icon">
                <svg
                  width={16}
                  height={16}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20ZM15.5355 7.05025L16.9497 8.46447L12 13.4142L10.5858 12L15.5355 7.05025Z"></path>
                </svg>
              </div>{" "}
              {stats?.inprogress} In Progress
            </div>
            <div className="graph-info-wrap yt-start">
              <div class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={32}
                  height={32}
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M17.6177 5.9681L19.0711 4.51472L20.4853 5.92893L19.0319 7.38231C20.2635 8.92199 21 10.875 21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 8.02944 7.02944 4 12 4C14.125 4 16.078 4.73647 17.6177 5.9681ZM12 20C15.866 20 19 16.866 19 13C19 9.13401 15.866 6 12 6C8.13401 6 5 9.13401 5 13C5 16.866 8.13401 20 12 20ZM11 8H13V14H11V8ZM8 1H16V3H8V1Z"></path>
                </svg>
              </div>{" "}
              {stats?.notStarted} Yet to Start
            </div>
            <div className="graph-info-wrap overdue">
              <div class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={32}
                  height={32}
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM9 9V15H15V9H9Z"></path>
                </svg>
              </div>{" "}
              {stats?.overdue} Overdue
            </div>
          </div>
        </div>
        <div className="course-info-table">
          <table class="table mb-0 office_list table-striped video-list">
            <thead>
              <tr>
                <th className="srno">Sl. No</th>
                <th className="name-tile">Video Name</th>
                <th>Status</th>
                <th>Progress %</th>
              </tr>
            </thead>
            <tbody>
              {!_.isEmpty(profileReports)
                ? profileReports?.map((item) => {
                    return (
                      <tr>
                        <td>{item?.sl_no}</td>
                        <td>{item?.name}</td>
                        <td>{item?.status}</td>
                        <td>
                          <div className="progress-box">
                            <span className="countprogre">
                              {item?.progress}%
                            </span>{" "}
                            <ProgressBar
                              variant="success"
                              now={item?.progress}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })
                : ""}
            </tbody>
          </table>
        </div>
      </div> */}
    </>
  );
};

export default ProfileDetailComponent;
